<template>
  <layouts-header></layouts-header>

  <breadcrumb :title="title" :text="text" :text1="text1" />

  <coach-dashboard-menu></coach-dashboard-menu>
  <div class="content court-bg">
    <div class="container">
      <!-- Sort By -->
      <div class="row">
        <div class="col-lg-12">
          <div class="sortby-section court-sortby-section">
            <div class="sorting-info">
              <div class="row d-flex align-items-center">
                <div class="col-xl-6 col-lg-6 col-sm-12 col-12">
                  <div class="coach-court-list">
                    <ul class="nav">
                      <li>
                        <router-link to="/coaches/coach-earning">Court</router-link>
                      </li>
                      <li>
                        <router-link to="/coaches/earning-coaching">Coaching</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-sm-12 col-12">
                  <div class="sortby-filter-group">
                    <div class="sortbyset">
                      <span class="sortbytitle">Sort By</span>
                      <div class="sorting-select">
                        <vue-select
                          :options="RelevanceEarnCoach"
                          id="relevanceearncoach"
                          placeholder="Relevance"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sort By -->

      <div class="row">
        <div class="col-md-12 col-lg-12">
          <!-- Chart -->
          <div class="card card-chart-blk">
            <div class="coache-head-blk">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="court-table-head">
                    <h4>Invoices</h4>
                    <p>Effortlessly manage court booking earnings</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="sortby-section invoice-sort">
                    <div class="sorting-info">
                      <div class="sortby-filter-group court-sortby">
                        <div class="sortbyset week-bg me-0">
                          <div class="sorting-select">
                            <vue-select
                              :options="EarnWeekCoach"
                              id="earnweekcoach"
                              placeholder="This Week"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <apexchart
                type="bar"
                height="300"
                :options="coachbar.earningbar"
                :series="coachbar.series"
              ></apexchart>
            </div>
          </div>
          <!-- /Chart -->
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="court-tab-content">
            <div class="card card-tableset">
              <div class="card-body">
                <div class="coache-head-blk">
                  <div class="row align-items-center">
                    <div class="col-md-5">
                      <div class="court-table-head">
                        <h4>Invoices</h4>
                        <p>Lorem Ipsum is simply dummy text of the printing</p>
                      </div>
                    </div>
                    <div class="col-md-7">
                      <div class="table-search-top invoice-search-top">
                        <div id="tablefilter">
                          <div class="dataTables_filter">
                            <label> 
                                <input type="search" class="form-control form-control-sm" placeholder="Search" aria-controls="DataTables_Table_0">
                            </label>
                          </div>
                        </div>
                        <div class="request-coach-list select-filter">
                          <div class="sortby-filter-group court-sortby">
                            <div class="sortbyset m-0">
                              <div class="sorting-select">
                                <vue-select
                                  :options="EarnInvoicesCoach"
                                  id="earninvoicescoach"
                                  placeholder="All Invoices"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <a-table class="table datatable" :columns="columns" :data-source="data">
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'PlayerName'">
                        <h2 class="table-avatar">
                          <router-link
                            to="/coaches/my-profile"
                            class="avatar avatar-sm flex-shrink-0"
                            ><img
                              class="avatar-img"
                              :src="
                                require(`@/assets/img/profiles/${record.PlayerImage}`)
                              "
                              alt="User"
                          /></router-link>
                          <span class="table-head-name table-name-user flex-grow-1">
                            <router-link to="/coaches/my-profile">{{
                              record.PlayerName
                            }}</router-link>
                          </span>
                        </h2>
                      </template>
                      <template v-else-if="column.key === 'LessonType'">
                        <div>{{ record.LessonType }}</div>
                      </template>
                      <template v-else-if="column.key === 'Date'">
                        <div class="table-date-time">
                          <h4>
                            {{ record.Date }}<span>{{ record.Time }}</span>
                          </h4>
                        </div>
                      </template>
                      <template v-else-if="column.key === 'Payment'">
                        <div>
                          <span class="pay-dark">{{ record.Payment }}</span>
                        </div>
                      </template>
                      <template v-else-if="column.key === 'AdditionalGuests'">
                        <div>{{ record.AdditionalGuests }}</div>
                      </template>
                      <template v-else-if="column.key === 'PaidOn'">
                        <div>{{ record.PaidOn }}</div>
                      </template>
                      <template v-else-if="column.key === 'Download'">
                        <div class="text-pink view-detail-pink">
                          <a href="javascript:;"
                            ><i class="feather-download"></i>Download</a
                          >
                        </div>
                      </template>
                      <template v-else-if="column.key === 'action'">
                        <div class="text-end">
                          <div class="dropdown dropdown-action table-drop-action">
                            <a
                              href="javascript:void(0);"
                              class="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              ><i class="fas fa-ellipsis-h"></i
                            ></a>
                            <div class="dropdown-menu dropdown-menu-end">
                              <a class="dropdown-item" href="javascript:void(0);"
                                ><i class="feather-edit"></i>Edit</a
                              >
                              <a class="dropdown-item" href="javascript:void(0);"
                                ><i class="feather-trash"></i>Delete</a
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
            <div class="tab-footer">
              <div class="row">
                <div class="col-md-6">
                  <div id="tablelength">
                    <div class="dataTables_length" id="DataTables_Table_0_length">
                      <label>Show
                        <select class="custom-select custom-select-sm form-control form-control-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="-1">All</option>
                        </select>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div id="tablepage">
                    <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                      <ul class="pagination">
                        <li class="paginate_button page-item previous disabled" id="DataTables_Table_0_previous"><a
                            href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
                            class="page-link"><i class="feather-chevrons-left"></i></a></li>
                        <li class="paginate_button page-item active"><a href="javascript:void(0);"
                            aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a></li>
                        <li class="paginate_button page-item next disabled" id="DataTables_Table_0_next"><a
                            href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0"
                            class="page-link"><i class="feather-chevrons-right"></i></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
const columns = [
  {
    title: "Player Name",
    dataIndex: "PlayerName",
    key: "PlayerName",
    sorter: {
      compare: (a, b) => {
        a = a.PlayerName.toLowerCase();
        b = b.PlayerName.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Lesson Type",
    dataIndex: "LessonType",
    key: "LessonType",
    sorter: {
      compare: (a, b) => {
        a = a.LessonType.toLowerCase();
        b = b.LessonType.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date & Time",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toLowerCase();
        b = b.Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Payment",
    dataIndex: "Payment",
    key: "Payment",
    sorter: {
      compare: (a, b) => {
        a = a.Payment.toLowerCase();
        b = b.Payment.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Additional Guests",
    dataIndex: "AdditionalGuests",
    key: "AdditionalGuests",
    sorter: {
      compare: (a, b) => {
        a = a.AdditionalGuests.toLowerCase();
        b = b.AdditionalGuests.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Paid On",
    dataIndex: "PaidOn",
    key: "PaidOn",
    sorter: {
      compare: (a, b) => {
        a = a.PaidOn.toLowerCase();
        b = b.PaidOn.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Download",
    dataIndex: "Download",
    key: "Download",
    sorter: {
      compare: (a, b) => {
        a = a.Download.toLowerCase();
        b = b.Download.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];
const data = [
  {
    PlayerName: "Andy",
    LessonType: "Single Lesson",
    Date: "Mon, Jul 12",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$100",
    AdditionalGuests: "3",
    PlayerImage: "avatar-02.jpg",
    PaidOn: "Mon, Jul 12",
  },
  {
    PlayerName: "Johnson",
    LessonType: "Onetime",
    Date: "Mon, Jul 10",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$120",
    AdditionalGuests: "2",
    PlayerImage: "avatar-01.jpg",
    PaidOn: "Mon, Jul 10",
  },
  {
    PlayerName: "Pranika",
    LessonType: "Single Lesson",
    Date: "Mon, Jul 13",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$220",
    AdditionalGuests: "4",
    PlayerImage: "avatar-06.jpg",
    PaidOn: "Mon, Jul 13",
  },
];
import { coachbar } from "./data";
export default {
  data() {
    return {
      coachbar: coachbar,
      title: "Earnings",
      text: "Home",
      text1: "Earnings",
      EarnWeek: ["This Week", "One Day"],
      RelevanceEarn: ["Relevance", "Price"],
      EarnInvoices: ["All Invoices", "Completed", "Inprogress"],
      data,
      columns,
    };
  },
};
</script>
